import { EmptyState } from '@app/components/base/EmptyState';
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import { defineMessage, FormattedMessage } from 'react-intl';

const missingAudiosReportEmptyHelp = defineMessage({
  id: 'audit.missingAudios.emptyState.help',
  defaultMessage:
    'Lista los IDs de material para aquellos schedules en el rango seleccionado cuya media de referencia no fue cargado para la emisora vinculada. Sirve para encontrar schedules sin media para detectar.',
});

/**
 * Placeholder shown before the first missing-audios report run, explaining what the report calculates.
 */
export function MissingAudiosReportEmptyState() {
  return (
    <EmptyState
      icon={CloudOffOutlinedIcon}
      message={false}
      help={<FormattedMessage {...missingAudiosReportEmptyHelp} />}
    />
  );
}
